import { SetSockMessagesType } from "../action-types";

export const SetSockMessages = (message: any) => {
  //TODO define type for this message rather using any!
  return {
    type: SetSockMessagesType.SET_SOCKMESSAGES,
    payload: message,
  };
};
